// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"Select_labelWrapper__2dqmG","wrapper":"Select_wrapper__2OlYJ","error":"Select_error__2PFMi"};